import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { accessService } from '../../services/central-api/access';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    zIndex: number;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function TagsDropdown({ value, setValue, zIndex, form, fieldName }: Props) {
    const [selectableTags, setSelectableTags] = useState<{ label: string; value: number; }[]>([]);

    async function loadTags() {
        try {
            const tags = await accessService.getUserTags();
            if (!tags) {
                setSelectableTags([]);
            } else {
                setSelectableTags(tags.map((tag) => {
                    return {
                        value: tag.id || 0,
                        label: tag.name
                    };
                }));
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        loadTags();
    }, []);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('tags')}
            items={selectableTags}
            multiple={true}
            mode='BADGE'
            zIndex={zIndex}
            fieldName={fieldName}
            form={form}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('tags')}
                items={selectableTags}
                multiple={true}
                mode='BADGE'
                setValue={setValue}
                value={value}
                zIndex={zIndex}
            />
        );
    }
}

export default TagsDropdown;
